import { Context, Schema } from "effect"

//
// The service is the name of the service usually the name in the package.json
// that the service is authenticated as. This powers all service to service
// api authentication.
//

const SrvSchema = Schema.String.pipe(Schema.brand("@superwall/api/srv"))
export const Srv = {
  Schema: SrvSchema,
  make: (value: string) => Schema.decode(SrvSchema)(value),
  makeUnsafe: (value: string) => value as typeof SrvSchema.Type,
}
const CfgValueSchema = Schema.Union(
  Schema.Literal("dev"),
  Schema.Literal("stg"),
  Schema.Literal("prd")
)
const CfgSchema = CfgValueSchema.pipe(Schema.brand("@superwall/api/cfg"))
export const Cfg = {
  Schema: CfgSchema,
  make: (value: typeof CfgValueSchema.Type) => Schema.decode(CfgSchema)(value),
  makeUnsafe: (value: typeof CfgValueSchema.Type) => value as typeof CfgSchema.Type,
}

class CurrentServiceSchema extends Schema.Class<CurrentServiceSchema>(
  "@superwall/api/CurrentService"
)({
  srv: Srv.Schema,
  cfg: Cfg.Schema,
}) {}

class CurrentServiceContext extends Context.Tag("@superwall/api/CurrentService")<
  CurrentServiceContext,
  CurrentServiceSchema
>() {}

const CurrentServiceOptional = CurrentServiceSchema.pipe(Schema.Option)

class CurrentServiceOptionalContext extends Context.Tag("@superwall/api/CurrentServiceOptional")<
  CurrentServiceOptionalContext,
  typeof CurrentServiceOptional.Type
>() {}

export const Type = CurrentServiceSchema.Type
export {
  CurrentServiceSchema as Schema,
  CurrentServiceOptional as OptionalSchema,
  CurrentServiceContext as Context,
  CurrentServiceOptionalContext as OptionalContext,
}
